import OpenInvoicesMainPage from "../components/OpenInvoices/OpenInvoicesMainPage";

const InvoicesPage = () => {
  return <OpenInvoicesMainPage />;
};

export default InvoicesPage;
